<template>
  <v-app
    :dark="darkMode"
    id="inspire"
    :class="[{
      'box-layout': boxLayout,
      'collapse-sidebar': collapseSidebar,
      'rtl-layout': rtlLayout,
      'cloudApp': $targetMake.isSeller
    }]"
  >
    <router-view/>
    <!-- MsgPopup -->
    <dialog-popup></dialog-popup>
  </v-app>
</template>

<script>
// import DialogPopup from '@/components/DialogPopup'
import callEvent from '@/components/mixin/call/callEvent'
import { mapGetters } from 'vuex'

/**
 * Talk Operation / Talk Operation 제외한 다른 페이지
 * 공통으로 사용하는 컴포넌트 없음
 * -> 최상위인 App.vue에 callEvent mixin 추가
 * **/
export default {
  name: 'App',
  metaInfo () {
    return {
      title: `クラウドベースのチャット相談ソリューション`,
      titleTemplate: `${this.$targetMake.text.titleKR} - %s`,
      link: [
        { rel: 'shortcut icon', type: 'image/png', href: this.$targetMake.images.appIcon }
      ]
    }
  },
  mixins: [callEvent],
  // components: {
  //   DialogPopup
  // },
  computed: {
    ...mapGetters([
      'darkMode',
      'collapseSidebar',
      'boxLayout',
      'rtlLayout',
      'selectedLocale'
    ])
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue